import { createRoot, hydrateRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

// IMPORTANT: Only add bot detection if it's clearly a bot
// The previous regex was too aggressive and might be affecting calculations
const isBot = /googlebot|adsbot-google|mediapartners-google|adsense|crawler/i.test(
  navigator.userAgent || ''
);

// For bots only, no impact on regular users
if (isBot) {
  // Simpler bot signaling
  const meta = document.createElement('meta');
  meta.name = 'robots-content-generated';
  meta.content = 'true';
  document.head.appendChild(meta);
}

// Prevent AdSense errors in development
const isDevelopment = import.meta.env.DEV;
if (isDevelopment) {
  // Mock AdSense functions to prevent errors
  window.adsbygoogle = window.adsbygoogle || [];
  const originalPush = Array.prototype.push;
  window.adsbygoogle.push = function(...args: any[]): number {
    // No-op in development, but return length like Array.push()
    return originalPush.apply(window.adsbygoogle, args);
  };
  
  // Mock other AdSense-related functions
  window.atAsyncOptions = [];
  window.dataLayer = window.dataLayer || [];
}

// Support both hydration and fresh rendering
if (rootElement.innerHTML.trim().length > 0) {
  hydrateRoot(rootElement, <App />);
} else {
  createRoot(rootElement).render(<App />);
}